module.exports = __webpack_public_path__ + "static/media/ICON_CAMERA_ACTIVE.0f411033.svg";